
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CronFilterInterface, CronSettingsRepositoryInterface } from '@/services/QA/cron-settings/interfaces';

@Component({
  inject: [
    'cronSettingsRepository',
  ],
})
export default class DeleteFilterDialog extends Vue {
  private readonly cronSettingsRepository!: CronSettingsRepositoryInterface;

  @Prop() private readonly filter!: CronFilterInterface;

  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete filter ${this.filter.property}?`;
  }

  private async deleteFilter(): Promise<void> {
    try {
      await this.cronSettingsRepository.deleteFilter(this.filter.id);
      this.$successDialog.show(`Filter ${this.filter.property} has been deleted.`);
      this.$emit('deleted-filter');
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response.data.message);
      this.destroyComponent();
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
